import { useDispatch, useSelector } from 'react-redux';
import { EventsState } from '../../../store/types';
import { Color } from '../../../types/working-model';
import classNames from 'classnames';
import { ListGridCheckbox } from './document-item';
import { checkContent } from '../../../store/actions/admin/content-actions';
import ColorPack, { ColorEditModal } from '../create/settings/design/colors/color';
import { useState } from 'react';
import { useCallback } from 'react';

interface PaletteItemProps {
	palette: Color
}
export default function PaletteItem({ palette }: PaletteItemProps): JSX.Element {
	const {
		ContentReducer: {
			checkedSet,
			view
		},
		AuthReducer: {
			token
		}
	} = useSelector((state: EventsState) => state);
	const [isEditing, setIsEditing] = useState(false);
	const dispatch = useDispatch();
	const handleCheck = () => dispatch(checkContent(palette.color_pack));
	const handleEdit = () => {
		if (listView) { setIsEditing(true); }
	};
	const isChecked = checkedSet.has(palette.color_pack);
	const listView = view === "list";
	const gridView = view === "grid";
	const uploadedAt = new Date(palette.created_at).toLocaleDateString();

	const closeColorModal = useCallback(() => {
		setIsEditing(false);
	}, []);

	return (
		<li className={classNames("content-item palette", `${view}-item`)}>
			<ListGridCheckbox isChecked={isChecked} onChange={handleCheck} id={palette.color_pack} gridView={gridView} />
			{gridView && <ColorPack color={palette} onClick={() => null} selected={false} />}

			{listView && (
				<>
					<p className="item-title grid-span" onDoubleClick={handleEdit}>{palette.title}</p>
					<p>{uploadedAt}</p>
					<hr className="hr" />
					<div className="colors-container">
						<ColorEditModal
							modalTitle="Edit Color Palette"
							isOpen={isEditing}
							onClose={closeColorModal}
							token={token!}
							color={palette}
						/>
					</div>
				</>
			)}
		</li>
	);
}